import { render, staticRenderFns } from "./CreateTabModal.vue?vue&type=template&id=2c9bee67&scoped=true"
import script from "./CreateTabModal.vue?vue&type=script&lang=js"
export * from "./CreateTabModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTabModal.vue?vue&type=style&index=0&id=2c9bee67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9bee67",
  null
  
)

export default component.exports